import { css } from 'styled-components';
import { NavItemProps } from '../../../../../components/InPageNav/InPageNavMobile/NavItemMobile/styles';
import spacing from '../../../../../helpers/spacing';
import { colors } from '../../../colors';
import { fonts } from '../../../fonts';

export default css<NavItemProps>`
  && {
    color: ${colors.neutral02};
    ${fonts.paragraphSmall};
    border-left: none;
    border-bottom: solid 1px ${colors.neutral04};
    padding: ${spacing(2)} 0;

    &:first-child {
      padding-top: ${spacing(2)};
    }
    &:last-child {
      padding-bottom: ${spacing(2)};
    }

    ${({ active }) =>
      !!active &&
      css`
        color: ${colors.core01};
        ${fonts.paragraph};
        font-weight: 500;
        border-bottom: solid 2px ${colors.core01};
      `}
  }
`;
